import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const EyeIcon = (props: SvgProps) => (
  <Svg
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <Path
      fill="#000"
      d="M12.005 15.062c.99 0 1.83-.347 2.52-1.04.691-.694 1.037-1.536 1.037-2.527 0-.99-.347-1.83-1.04-2.521-.694-.69-1.536-1.036-2.527-1.036-.99 0-1.83.347-2.521 1.04-.69.694-1.036 1.536-1.036 2.527 0 .99.347 1.83 1.04 2.52.694.691 1.536 1.037 2.527 1.037Zm-.003-.893c-.741 0-1.372-.26-1.892-.778a2.57 2.57 0 0 1-.78-1.89c0-.74.26-1.37.779-1.89a2.57 2.57 0 0 1 1.89-.78c.74 0 1.37.26 1.89.778.52.518.78 1.148.78 1.89 0 .74-.26 1.37-.778 1.89a2.57 2.57 0 0 1-1.89.78Zm0 3.708c-2.126 0-4.064-.58-5.814-1.74C4.44 14.98 3.125 13.434 2.246 11.5c.879-1.933 2.192-3.479 3.94-4.638 1.747-1.16 3.684-1.739 5.811-1.739s4.065.58 5.814 1.739c1.75 1.16 3.064 2.705 3.943 4.638-.88 1.933-2.192 3.479-3.94 4.638-1.747 1.16-3.684 1.739-5.811 1.739ZM12 16.954c1.86 0 3.574-.49 5.14-1.47a9.576 9.576 0 0 0 3.583-3.984 9.576 9.576 0 0 0-3.582-3.984A9.507 9.507 0 0 0 12 6.046c-1.86 0-3.574.49-5.14 1.47A9.576 9.576 0 0 0 3.276 11.5a9.576 9.576 0 0 0 3.582 3.983 9.507 9.507 0 0 0 5.14 1.47Z"
    />
  </Svg>
)
export default EyeIcon
